module.exports = __webpack_public_path__ + "baaf6eb3a8ddd436875622237ee5d2a5.jpg";